import { ReactNode } from "react";

import { Tooltip, TooltipProps } from "components/Tooltip";


function TooltipWrapper(
  {
    tooltip,
    children
  }: {
    tooltip: TooltipProps["content"] | undefined,
    children: ReactNode
  }
) {
  if (tooltip) {
    return <Tooltip content={ tooltip }>{ children }</Tooltip>;
  } else {
    return <>{ children }</>;
  }
}


export default function InputFieldLabel(
  {
    label,
    extraLabel,
    required = false,
    tooltip
  }: {
    label: ReactNode,
    extraLabel?: ReactNode,
    required?: boolean,
    tooltip?: TooltipProps["content"],
  }
) {
  return (
    <div className="flex flex-row gap-x-1 items-center">
      { required && <span className="text-error-600">*</span> }
      <TooltipWrapper tooltip={ tooltip }>
        { label }
      </TooltipWrapper>
      { extraLabel && <span className="text-gray-500 dark:text-neutral-400">{ extraLabel }</span> }
    </div>
  );
};
